import { type FC } from "react";
import { type Association } from "@entities";
import { RelevantVolunteersPanel } from "./RelevantVolunteersPanel";
import "./RelevantVolunteersSection.scss";

interface RelevantVolunteersSectionProps {
  opportunityId: string;
  standalone?: boolean;
  tourAnchors?: boolean;
  previewRows?: Association[];
  onSendSuccess?: (result: {
    sent: number;
    failed: number;
    skipped?: number;
    message: string;
  }) => void;
  onAddSuccess?: () => void;
}

export const RelevantVolunteersSection: FC<RelevantVolunteersSectionProps> = ({
  opportunityId,
  standalone = false,
  onSendSuccess,
  onAddSuccess,
  tourAnchors = false,
  previewRows,
}) => {
  return (
    <div
      className={`relevant-volunteers-section${standalone ? " standalone" : ""}`}
      data-tour={tourAnchors ? "cc-relevant-volunteers" : undefined}
    >
      <p className="par">מתנדבים רלוונטיים</p>
      <div className="relevant-volunteers-section-content">
        <RelevantVolunteersPanel
          key={opportunityId}
          opportunityId={opportunityId}
          standalone={standalone}
          previewRows={previewRows}
          onSendSuccess={onSendSuccess}
          onAddSuccess={onAddSuccess}
        />
      </div>
    </div>
  );
};
